import { useCallback, useEffect, useMemo, useState } from "react";
import { fetchPartylists } from "services/services.affiliation";
import { getFormattedOptions } from "utility/helpers";

const usePartylists = () => {
  const [partyList, setPartyList] = useState([]);

  const refetch = useCallback(() => {
    fetchPartylists({
      callback: (data) => {
        setPartyList(data);
      },
    });
  }, []);

  const options = useMemo(() => {
    return getFormattedOptions("name", partyList);
  }, [partyList]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: partyList,
    options,
    refetch,
  };
};

export default usePartylists;
